<template>
	<div class="itv-modal-default" :class="{ 'form-success': formSuccess }">
		<div
			class="itv-modal-default__overlay"
			:class="{ active: active }"
			aria-label="Закрыть модальное окно"
			@click="hideModal"
		></div>
		<div class="itv-modal-default__wrapper" :class="{ active: active }">
			<div
				class="itv-modal-default__header"
				aria-label="Закрыть модальное окно"
				@click.prevent="hideModal"
			>
				<div class="itv-modal-default__title">
					<slot name="header"></slot>
				</div>
				<button class="itv-modal-default__close"></button>
			</div>
			<div class="itv-modal-default__scroll">
				<div class="itv-modal-default__content">
					<slot name="content"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ModalDefault',
	props: {
		formSuccess: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			active: false,
		}
	},
	computed: {
		isMobile() {
			return window.innerWidth < 768
		},
	},
	methods: {
		hideModal() {
			let timeout = 100

			if (this.isMobile) {
				timeout = 300
			}

			this.active = false
			setTimeout(() => {
				this.$emit('hideModal')
			}, timeout)
		},
	},
	mounted() {
		setTimeout(() => {
			this.active = true
		}, 100)

		document.body.classList.add('body-lock-scroll')
	},
	unmounted() {
		document.body.classList.remove('body-lock-scroll')
	},
}
</script>
